export type Attributes = Record<string, unknown>
export type Jsonb = Record<string, unknown>

export type TabTypes = 'Overview' | 'Quality' | 'ESG Metrics'

export interface ClientOptions {
  params?: any
  headers?: Record<string, string>
  json?: any
  body?: any
  method?: 'POST' | 'GET' | 'PUT' | 'DELETE' | 'PATCH' | 'OPTIONS' | 'HEAD'
  skipError?: boolean
  form?: any
}

// On the event sometimes a number is sent as a string. Luckily in those cases it will have a <property>@odata.type property added to the data, so we can look for those and parse any strings.
export type MaybeNumber = number | string

export type DateAsString = string

// Some fields might be missing, only the important ones are added
export interface AssetEvent {
  "odata.etag": string
  approved: boolean
  asset: string
  assetPath: string
  certificate: string
  comment: string
  conveyer_belt_co2_emission_total: MaybeNumber
  conveyer_belt_power_consumption_max: MaybeNumber
  conveyer_belt_power_consumption_mean: MaybeNumber
  conveyer_belt_power_consumption_min: MaybeNumber
  conveyer_belt_power_consumption_periodic: string
  deviceId: string
  enqueuedTimeUtc: DateAsString
  eventType: string
  extruder_1_co2_emission_total: MaybeNumber
  extruder_1_power_consumption_max: MaybeNumber
  extruder_1_power_consumption_mean: MaybeNumber
  extruder_1_power_consumption_min: MaybeNumber
  extruder_1_power_consumption_periodic: string
  gas_co2_emission_total: MaybeNumber
  gas_consumption_max: MaybeNumber
  gas_consumption_mean: MaybeNumber
  gas_consumption_min: MaybeNumber
  gas_consumption_periodic: string
  has_outer_diameter: boolean
  has_ovality: boolean
  has_wall_thickness: boolean
  ledgerHash: string
  out_of_bounds: boolean
  outer_diameter_max_acceptable: MaybeNumber
  outer_diameter_max: MaybeNumber
  outer_diameter_mean: MaybeNumber
  outer_diameter_min_acceptable: MaybeNumber
  outer_diameter_min: MaybeNumber
  outer_diameter_periodic: string
  outer_diameter_uom: string
  ovality_max_acceptable: MaybeNumber
  ovality_max: MaybeNumber
  ovality_mean: MaybeNumber
  ovality_min_acceptable: MaybeNumber
  ovality_min: MaybeNumber
  ovality_periodic: string
  ovality_uom: string
  PartitionKey: string
  recipe: string
  RowKey: string
  startTime: DateAsString
  stopTime: DateAsString
  throughput_points: MaybeNumber
  Timestamp: DateAsString
  ts: DateAsString
  uuid: string
  wall_thickness_max_acceptable: MaybeNumber
  wall_thickness_max: MaybeNumber
  wall_thickness_mean: MaybeNumber
  wall_thickness_min_acceptable: MaybeNumber
  wall_thickness_min: MaybeNumber
  wall_thickness_periodic: string
  wall_thickness_uom: string
}

export enum MeasurementStatus {
  Passed = 'passed',
  Failed = 'failed',
}

export interface MeasurementRecord {
  PartitionKey: string
  ts: number
  distance?: number
  value: number
}

export interface Datapoint {
  x: number | string
  y: number
}

export interface Dataset {
  label: string
  data: Datapoint[]
  backgroundColor?: string
  barPercentage?: number
  borderColor?: string
  categoryPercentage?: number
  fill?: boolean | string
  pointBackgroundColor?: string
  pointHitRadius?: number
  pointHoverRadius?: number
  pointRadius?: number
  pointStyle?: boolean
  showLine?: boolean
  tension?: number
}
